module.exports = __webpack_public_path__ + "static/visual_1_2_do-af106fdb632cc5889078978154d40a71.png";